import React from "react";
import {motion} from "framer-motion"
import ResumeCard from "./ResumeCard";

const Experience = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="py-12 font-titleFont flex gap-20"
    >
      <div>
        <div className="flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">2022 - 2025</p>
          <h2 className="text-4xl font-bold">Job Experience</h2>
        </div>
        <div className="mt-14 w-full border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
        <ResumeCard
            title="Graphic Design"
            subTitle="SWA softech pvt ltd Lucknow || Currently Working"
            result="SWA softech pvt ltd Lucknow"
            des="Delivered 150+ custom designs including ads, stories, and highlight covers for brands in retail and hospitality  
            Designed marketing materials such as posters, business cards, and brand merchandise  
            Partnered with copywriters and campaign strategists to ensure impactful visual communication
            
"
          />
           <ResumeCard
            title="Graphic Design"
            subTitle="Digital Trade Bazaar – Delhi | Jan 2023 – Aug 2024"
            result="Lucknow"
            des="Created over 300+ social media creatives for brands in education, fashion, and food industry
 	Designed logos, posters, and brochures using Canva & Photoshop
 	Collaborated	with	marketing	team	for	campaigns	and	client presentations.
"
          />
          <ResumeCard
            title="Freelance Graphic Designer "
            subTitle="Remote | Jan 2022 – Dec 2022"
            result="Lucknow"
            des="Worked	with	small	businesses	and	startups	to	develop	brand identity and Instagram content
            Delivered high-quality visuals with quick turnaround time.
            "
            
            />
         
     
       
        </div>
      </div>
    </motion.div>
  );
};

export default Experience;